import { Card, Col } from "reactstrap";
import { InverseTablePrimaryTitle } from "../../../../../constants";
import CommonTable from "./common/CommonTable";
import { InversePrimaryBody, InversePrimaryHeader, InverseTablePrimarySubTitle } from "../../../../../data/formsAndTable/tables/reactstrapTables/BasicTables";
import CommonCardHeader from "../../../../../coreComponents/CommonCardHeader";

const InverseTablePrimary = () => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={InverseTablePrimaryTitle} span={InverseTablePrimarySubTitle} headClass="pb-20" tag />
        <div className="table-responsive custom-scrollbar">
          <CommonTable strip={true} headData={InversePrimaryHeader} tableClass="bg-primary">
            {InversePrimaryBody.map((data) => (
              <tr key={data.id}>
                <th scope="row">{data.id}</th>
                <td>{data.firstName}</td>
                <td>{data.lastName}</td>
                <td>{data.company}</td>
                <td>{data.salary}</td>
                <td>{data.email}</td>
                <td>{data.position}</td>
                <td>{data.country}</td>
              </tr>
            ))}
          </CommonTable>
        </div>
      </Card>
    </Col>
  );
};
export default InverseTablePrimary;
